import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IVisaCountry } from "../visacountryModel";

export const getAllVisaCountries = createAsyncThunk(
  "VisaCountry/FindAllVisaCountry",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/VisaCountry/FindAllVisaCountry`,
        {
          VisaCountry: "",
          CurrencyCode: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching visa countries:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveVisaCountries = createAsyncThunk(
  "VisaCountry/FindAllActiveVisaCountry",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/VisaCountry/FindAllActiveVisaCountry`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching visa countries:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createVisaCountry = createAsyncThunk(
  "VisaCountry/InsertVisaCountry",
  async (CountryData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/VisaCountry/InsertVisaCountry`,
        CountryData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating visa country:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateVisaCountry = createAsyncThunk(
  "VisaCountry/UpdateVisaCountry",
  async (CountryData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/VisaCountry/UpdateVisaCountry`,
        CountryData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating visa country:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getVisaCountryByID = createAsyncThunk(
  "VisaCountry/FindByIDVisaCountry",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/VisaCountry/FindByIDVisaCountry`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result?.ID,
        VisaCountry: result?.VisaCountry,
        CurrencyCode: result?.CurrencyCode,
        DocumentID: result.DocumentID
          ? result.DocumentID?.split(",")?.map((e: string) => +e)
          : [],
        IsActive: result?.IsActive ? 1 : 2,
      } as IVisaCountry;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching country:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const visacountryActiveInactive = createAsyncThunk(
  "VisaCountry/ActiveInActiveVisaCountry",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/VisaCountry/ActiveInActiveVisaCountry`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive country:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteVisaCountry = createAsyncThunk(
  "VisaCountry/DeleteVisaCountry",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/VisaCountry/DeleteVisaCountry`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting country:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getVisaCountryWiseDocumentData = createAsyncThunk(
  "VisaCountry/VisaCountryWiseDocumentData",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/VisaCountry/VisaCountryWiseDocumentData`,
        { ID }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Visa Document:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
